<template>
    <!-- Topbar -->
        <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

          <!-- Sidebar Toggle (Topbar) -->
          <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3" @click="toggleSideBar">
            <i class="fa fa-bars"></i>
          </button>
 
          <span style="cursor:pointer" @click="$router.back()" class="text-primary"> <i class="fa fa-chevron-left text-primary mr-2"></i>Буцах</span>
          
          <!-- Topbar Search -->
          <!-- <form class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
            <div class="input-group">
              <input type="text" class="form-control bg-light border-0 small" placeholder="Search for..." aria-label="Search" aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-primary" type="button">
                  <i class="fas fa-search fa-sm"></i>
                </button>
              </div>
            </div>
          </form> -->



          <!-- Topbar Navbar -->
          <ul class="navbar-nav ml-auto">
            <div class="nav-item dropdown no-arrow mx-1" v-if="currentUser!=null && userProfile!=null && userProfile.role=='student'">
              <a class="nav-link" style="cursor:pointer">
                <span class="mx-2 p-2" @click="changeLanguage('mn')" v-bind:class="[lang=='mn' ? 'bg-danger text-white' : 'bg-default text-dark']">MN</span>
                <span class="mx-2 p-2" @click="changeLanguage('english')" v-bind:class="[lang=='english' ? 'bg-danger text-white' : 'bg-default text-dark']">Eng</span>
              </a>
            </div>

            <!-- Nav Item - Alerts -->
            <li class="nav-item dropdown no-arrow mx-1" style="display:none">
              <a class="nav-link dropdown-toggle" href="#" id="alertsDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-bell fa-fw"></i>
                <!-- Counter - Alerts -->
                <span class="badge badge-danger badge-counter">3+</span>
              </a>
              <!-- Dropdown - Alerts -->
              <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="alertsDropdown">
                <h6 class="dropdown-header">
                  Alerts Center
                </h6>
                <a class="dropdown-item d-flex align-items-center" href="#">
                  <div class="mr-3">
                    <div class="icon-circle bg-primary">
                      <i class="fas fa-file-alt text-white"></i>
                    </div>
                  </div>
                  <div>
                    <div class="small text-gray-500">December 12, 2019</div>
                    <span class="font-weight-bold">Зар 1</span>
                  </div>
                </a>
                <a class="dropdown-item d-flex align-items-center" href="#">
                  <div class="mr-3">
                    <div class="icon-circle bg-success">
                      <i class="fas fa-donate text-white"></i>
                    </div>
                  </div>
                  <div>
                    <div class="small text-gray-500">December 7, 2019</div>
                    Зар 2
                  </div>
                </a>
                
                <a class="dropdown-item d-flex align-items-center" href="#">
                  <div class="mr-3">
                    <div class="icon-circle bg-warning">
                      <i class="fas fa-exclamation-triangle text-white"></i>
                    </div>
                  </div>
                  <div>
                    <div class="small text-gray-500">December 2, 2019</div>
                    Зар 3
                  </div>
                </a>
                <a class="dropdown-item text-center small text-gray-500" href="#">Бүх заруудыг харах</a>
              </div>
            </li>


            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">
              <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="mr-2 d-none d-lg-inline text-gray-600 small">
                  <span v-if="userProfile!=null && userProfile.code!=null && userProfile.code!=undefined">{{userProfile.code}}</span>
                  <span v-else><span v-if="userProfile!=null && userProfile.email!=null">{{userProfile.email}}</span></span>
                </span>
              </a>
              <!-- Dropdown - User Information -->
              <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                <div @click="editProfile" class="dropdown-item" style="cursor:pointer">
                  <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                  Хувийн мэдээлэл
                </div>
                <!-- <a class="dropdown-item" href="#">
                  <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                  Settings
                </a>
                <a class="dropdown-item" href="#">
                  <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                  Activity Log
                </a> -->
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" @click="logout" data-toggle="modal" data-target="#logoutModal">
                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  Системээс гарах
                </a>
              </div>
            </li>

          </ul>

        </nav>
        <!-- End of Topbar -->
</template>

<script>
const fb = require('../firebaseConfig.js')
import { mapState } from 'vuex'
import mixin from './global/mixin.js';
import { store } from "../store.js";
export default {
  name: "ContentNav",
  data() {
    return {

    };
  },

  methods: {
    editProfile(){
        this.$router.push({ name: 'UserProfile'});
    },
    logout() {
        fb.auth.signOut().then(() => {
            this.$store.dispatch('clearData')
            this.$router.push('/login')
        }).catch(err => {
            console.log(err)
        })
    },
    changeLanguage(ln){
      store.dispatch('updateLang', ln)   
      // store.commit('lang', ln);
    }

  },
  computed: {
      ...mapState(['currentUser', 'userProfile', 'lang'])
  },
  mixins:[mixin]
  
};
</script>

